import {IBook} from "@/interfaces/book.interface";

export namespace ICarUnion {
  export interface IEntity {
    car1Number: string;
    car2Number: string;
    car3Number: string;
    car4Number: string;
    carHistory1: string;
    carHistory2: string;
    carHistory3: string;
    comment: string;
    corpId: number;
    corpName: string;
    personName: string;
    phone: string;
    login: string;
    password: string;
    hasActiveCars: number;
    hasArchiveCars: number;
    hasParkedCars: number;
    lastCarMovs: string;
    parks: number[];
    dateBeg: string;
    saldo: number;
  }

  export enum PropType {
    Input = 'input',
    Password = 'password',
    Textarea = 'textarea',
    Select = 'select',
    Date = 'date',
    DateText = 'dateText',
    Text = 'text',
    NumberFormatted = 'numberFormatted',
    Custom = 'custom',
    SubProps = 'subProps',
  }

  export interface ITableCell {
    propType: PropType;
    prop: string;
    placeholder?: string;
    label?: string;
    options?: IBook.CatalogData[];
    canCreate?: boolean;
    multiple?: boolean;
    titleProp?: string;
    subProps?: ITableCell[];
  }

  export const DefaultCarUnion: IEntity = {
    car1Number: '',
    car2Number: '',
    car3Number: '',
    car4Number: '',
    carHistory1: '',
    carHistory2: '',
    carHistory3: '',
    comment: '',
    corpId: null,
    corpName: '',
    personName: '',
    phone: '',
    login: '',
    password: '',
    hasActiveCars: null,
    hasArchiveCars: null,
    hasParkedCars: null,
    lastCarMovs: '',
    parks: [],
    dateBeg: '',
    saldo: null,
  };

  export enum EmitterEvents {
    ActivateNewRow = 'cars-union:activate-new-row',
  }
}
